<template>
  <div class="UserInfoSet">
    <van-nav-bar title="设置" fixed border @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group class="self">
      <van-cell class="name">
        <template slot="icon">
          <van-image class="err-image-header" :src="attach_url+userInfo.u_headportrait"/>
        </template>
        <template slot="title">
          <span>{{userFriend.f_name ? userFriend.f_name : userInfo.u_nickname}}</span>
          <van-icon name="static/icon/man.png" v-if="userInfo.u_sex === 1" />
          <van-icon name="static/icon/woman.png" v-else-if="userInfo.u_sex === 0" />
          <br />
          <span>{{userFriend.f_name ? userInfo.u_nickname : ''}}</span>
        </template>
        <template slot="label">
          <span>账号：{{userInfo.u_login_id}}</span>
        </template>
      </van-cell>
      <van-cell class="signature">
        <template slot="icon">
          <van-icon name="static/icon/biaoqian.png" />
        </template>
        <template slot="title">
          <span class="custom-title">个性签名</span>
        </template>
        <template slot="label">
          <span>{{userInfo.u_signature}}</span>
        </template>
      </van-cell>
      <van-cell is-link @click="setRemarkName(userFriend.f_name)">
        <template slot="title">
          <span class="custom-title">备注</span>
        </template>
        <template slot="default">
          <span class="custom-title">{{userFriend.f_name ? userFriend.f_name : '未设置'}}</span>
        </template>
      </van-cell>
      <van-cell title="设为置顶">
        <van-switch v-model="stick" @click="onStick" />
      </van-cell>
      <van-cell title="消息免打扰">
        <van-switch v-model="noDisturbing" @click="onNoDisturbing" />
      </van-cell>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  name: "UserInfoSet",
  data() {
    return {
      friend_id: "",
      userInfo: [],
      userFriend: [],
      attach_url: this.Conf.serverPre,
      stick: localStorage.getItem(this.friend_id + "stick") == 1 ? true : false,
      noDisturbing:localStorage.getItem(this.friend_id + "noDisturbing") == 1 ? true: false,
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id")+"token"),
    };
  },
  methods: {
    loadData() {
      var params = {
        friend_id: this.friend_id,
        u_id: this.u_id,
        token: this.token
      };
      var url = this.Conf.serverUrl + "User/getFriendInfoById" +"?num="+Math.random();

      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          this.userInfo = response.data.result;
          this.userFriend = response.data.userFriend;
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "UserInfo",
        query: {
          friend_id: this.friend_id
        }
      });
    },
    // 设置备注名称
    setRemarkName(friend_name) {
      this.$router.push({
        name: "SetRemarkName",
        query: {
          friend_id: this.friend_id,
          friend_name: friend_name
        }
      });
    },
    // 设为置顶
    onStick() {
      var params = {
        friend_id: this.friend_id,
        sorting: this.stick == false ? 1 : 0,
        u_id: this.u_id,
        token: this.token
      };
      var url = this.Conf.serverUrl + "Friends/setFriendSort" +"?num="+Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch (response.data.code) {
            case 200:
              localStorage.setItem(
                this.friend_id + "stick",
                response.data.sorting
              );

              break;
            case 40001:
              break;
          }
        })
        .catch(error => {});
    },
    // 消息免打扰
    onNoDisturbing() {
      // console.log(this.noDisturbing);
      localStorage.setItem(
        this.friend_id + "noDisturbing",
        this.noDisturbing == false ? 1 : 0
      );
    },
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		}
  },
  created() {
		this.getStateConfigs();
    var query = this.$route.query;
    this.friend_id = query.friend_id;
    this.loadData();
    this.stick =
      localStorage.getItem(this.friend_id + "stick") == 1 ? true : false;
    this.noDisturbing =
      localStorage.getItem(this.friend_id + "noDisturbing") == 1 ? true : false;
  }
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/UserInfoSet.vue